module.exports = __webpack_public_path__ + "vancouver-universities.png?e63fe9755caa26dc0f2f425728fa702f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vancouver-universities.png
// module id = 154
// module chunks = 0